import React from 'react';
import { Drawer, Button, Input, Row, Col, Image } from 'antd';
import PlaneDetails from './PlaneDetails';
import { useState } from 'react';
import search from '../../images/Union.svg'
import Icon from "@ant-design/icons";
import locationIcon from '../../images/location.png'
import "/node_modules/flag-icons/css/flag-icons.min.css";
import { flagMap } from './const'

const PlaneListDrawer = (props) => {
    const [isPlaneModalOpen, setIsPlaneModalOpen] = useState(false)
    const [plane, setPlane] = useState(null)
    const [active, setActive] = useState('')

    const handlePlaneModalShow = () => {
        setIsPlaneModalOpen(!isPlaneModalOpen)
        setActive('')
    }
    const handleOnClick = (plane, index) => {
        handlePlaneModalShow()
        setPlane(plane)
        setActive(index)
    }
    const searchIcon = () => (
        <Image src={search} preview={false}/>
    )
    const location = () => (
        <Image src={locationIcon} preview={false}/>
    )

    const gotoMarker = (marker) => {
        props.globe.goTo(marker.position.latitude, marker.position.longitude, 10e4)
    }

    const GotoButton = (props) => {    
        return (
            <div className="plane-location-icon-box">
                <Icon component={location} onClick={(e) => gotoMarker(props.marker, e)}/>
            </div>
        );
    }
    return(
        <React.Fragment>
            <Drawer
                className='listDrawer planeListDrawer'
                title={<span className="drawerTitle">飞机列表</span>}
                placement="left"
                closable={false}
                onClose={props.handlePlaneDrawerShow}
                visible={props.isPlaneDrawerShow}
                getContainer={false}
                width={'450'}>
                <div className="drawerSearch">
                    <Input placeholder="请输入筛选条件……" type="text" onKeyUp={props.handleFilter}/>
                    <div className="drawerSearchIcon">
                        <Icon component={searchIcon}/>
                    </div>
                </div>
                {
                    props.filteredPlanes.map((item, index) => 
                        (
                            <Row className={active === index ? 'drawer-list-item-active drawer-list-item' : 'drawer-list-item'}>
                                <Col span={21}>
                                    <div style={{width:'100%', textAlign:'left'}} onClick={(e) => handleOnClick(item.plane, index, e)}>
                                        <span class={`fi fi-${flagMap[item.plane.cou]}`}></span>
                                        &nbsp;&nbsp;{item.plane.type+"  "+item.plane.reg+"  "+item.plane.icao}
                                    </div>
                                </Col>
                                <Col>
                                    <GotoButton marker={item.marker} globe={props.globe}/>  
                                </Col>
                            </Row>
                        )
                    )
                }
            </Drawer>
            {
                isPlaneModalOpen ?
                <PlaneDetails isModalOpen={isPlaneModalOpen} plane={plane} handleModalShow={handlePlaneModalShow}/> : ''
            }
        </React.Fragment>
    )
};

export default PlaneListDrawer;